import { __assign, __awaiter, __generator } from "tslib";
import { fetchSubEntities } from './http/fetch-sub-entitities';
import { FrequentlyAskedQuestionsFilterOption } from './models/frequently-asked-questions-filter-option';
import { SubEntityType } from './models/sub-entity-type';
export var fetchFrequentlyAskedQuestions = function (groupId, types, filter) { return __awaiter(void 0, void 0, void 0, function () {
    var additionalArgs, productCode, productSku, top_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (types && types.length > 0) {
                    additionalArgs = { types: types.join('|') };
                }
                if (filter) {
                    productCode = filter.productCode, productSku = filter.productSku, top_1 = filter.top;
                    additionalArgs = __assign(__assign({}, additionalArgs), (_a = {}, _a[FrequentlyAskedQuestionsFilterOption.ProductCode] = productCode, _a[FrequentlyAskedQuestionsFilterOption.ProductSku] = productSku, _a[FrequentlyAskedQuestionsFilterOption.Top] = top_1, _a));
                }
                return [4 /*yield*/, fetchSubEntities(groupId, SubEntityType.FrequentlyAskedQuestions, additionalArgs)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}); };
